import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  fill: "currentColor",
  viewBox: "0 0 84 67"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M50.71 19.386S69.45.167 69.6.1c.312-.141.56-.134.872.027.183.087 6.498 6.54 6.498 6.54s6.238 6.446 6.297 6.681c.111.415.085.716-.091 1.077-.124.262-4.323 4.606-19.84 20.552-17.359 17.826-30.525 31.221-31.04 31.569a.67.67 0 0 1-.332.121c-.482-.007-.579-.101-7.553-7.257-5.964-6.118-7.879-8.02-15.51-15.463-6.856-6.688-8.725-8.542-8.803-8.75-.137-.341-.13-.569.019-.897.079-.18 1.889-2.128 5.568-5.991 6.889-7.23 6.687-7.029 7.13-7.189.468-.168.859-.161 1.178.04.137.08 1.276 1.144 2.52 2.363 10.47 10.202 15.412 15.001 15.464 15.022.039.013 18.733-19.159 18.733-19.159" }, null, -1)
  ])))
}
export default { render: render }